/**
 * Facets pills for product list
 */

import './_facets-pager.twig';
import './_facets-pager.scss';

export const name = 'facets-pager';

export function disable() {}

/**
 * Enables this component.
 *
 * @param {jQuery} $context - A piece of DOM
 */
(function ($, $context) {
  // Find our component within the DOM
  const $facets = $('ul.facets', $context);
  const $facetsPager = $('.facets-pager', $context);
  // Bail if component does not exist
  if (!$facets.length || !$facetsPager.length) {
    return;
  }
  $facetsPager.find('a').click(function handler() {
    $facets.find('.facet-item-child__checkbox').attr('disabled', 'disabled');
  });
})(jQuery);
